import { Outlet, Link } from 'react-router-dom';
import Header from './header';
import Footer from './footer';

export default function Layout() {
  return (
    <div className="min-h-screen bg-life-gradient text-white">
      <Header />
        <main className="p-4">
            <Outlet />
        </main>
      <Footer />
    </div>
  );
}
